import { CButton } from "@coreui/react";
import P from "components/P";
import { t } from "i18next";
import Flex from "layouts/flex/Flex";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { useContext, useEffect } from "react";
import style from "./OrderListRow.module.css"
import NiceModal from "@ebay/nice-modal-react";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { addCommas, getCurrentLanguageCode } from "shared/utils/Utils";

function OrderListRow(props) {
    const { data, status } = props;
    const { isMobile } = useContext(BrowserDetectContext);
    

    return (
        <div className={style.wrap}>
            {
                isMobile
                    ?
                    <FlexChild>
                        <div className={style.tableHeaderWrap}>
                            <HorizontalFlex>
                                <FlexChild height={"120px"} borderRight={"1px solid #999"}>
                                    <HorizontalFlex>
                                        <FlexChild width={"max-content"}>
                                            <div className={style.imgWrap}>
                                                <img width={"85%"} src={data.thumbnail} />
                                            </div>
                                        </FlexChild>
                                        <FlexChild justifyContent={"flex-start"}>
                                            <VerticalFlex>
                                                <FlexChild>
                                                    <Center width={"100%"} textAlign={"left"}>
                                                        {data.free &&
                                                            <P color={"red"} size={12}>[이벤트 사은품]</P>
                                                        }
                                                        <P>{data.title}</P>
                                                        <P color={"#999"}>{data.description}</P>
                                                        <P>{t("quantity")} : {data.quantity}개</P>
                                                        {data.free ?
                                                            <P weight={"bold"} color={"gray"}>0 &#8361;</P>
                                                            :
                                                            <P weight={"bold"} color={"var(--main-color)"}>{addCommas(data.total)} &#8361;</P>
                                                        }
                                                    </Center>
                                                </FlexChild>
                                            </VerticalFlex>
                                        </FlexChild>

                                    </HorizontalFlex>
                                </FlexChild>

                                <FlexChild width={"120px"} justifyContent={"center"} height={"120px"} >
                                    <VerticalFlex>
                                        <P weight={"bold"}>{t("orderComplete")}</P>
                                        {/* <p onClick={onTrackOrderClick} className={style.trackButton}>{t("배송추적")}</p> */}
                                    </VerticalFlex>
                                </FlexChild>
                            </HorizontalFlex>
                        </div>
                    </FlexChild>
                    :
                    <FlexChild>
                        <div className={style.tableHeaderWrap}>
                            <HorizontalFlex>
                                <FlexChild height={"120px"} width={"130px"} justifyContent={"center"}>
                                    <div className={style.border}>
                                        <Center>
                                            <P>{props.time}</P>
                                            {/* <P size={"10pt"} color={"#999"}>{t("상세보기")}</P> */}
                                        </Center>
                                    </div>
                                </FlexChild>
                                <FlexChild height={"120px"} borderRight={"1px solid #999"}>
                                    <div className={style.border}>
                                        <HorizontalFlex>
                                            <FlexChild width={"max-content"}>
                                                <div className={style.imgWrap}>
                                                    <img width={"85%"} src={data.thumbnail} />
                                                </div>
                                            </FlexChild>
                                            <FlexChild justifyContent={"flex-start"}>
                                                <VerticalFlex>
                                                    <FlexChild>
                                                        <Center width={"100%"} textAlign={"left"}>
                                                            {data.free &&
                                                                <P color={"red"} size={12}>[이벤트 사은품]</P>
                                                            }
                                                            <P>{data.title}</P>
                                                            <P color={"#999"}>{data.description}</P>
                                                        </Center>
                                                    </FlexChild>
                                                </VerticalFlex>
                                            </FlexChild>
                                        </HorizontalFlex>
                                    </div>
                                </FlexChild>
                                <FlexChild width={"50px"} height={"120px"} justifyContent={"center"} borderRight={"1px solid #999"}>
                                    <div className={style.border}>
                                        <P>{data.quantity}개</P>
                                    </div>
                                </FlexChild>
                                <FlexChild width={"110px"} justifyContent={"center"} height={"120px"} borderRight={"1px solid #999"}>
                                    <div className={style.border}>
                                        {data.free ?
                                            <P weight={"bold"} color={"gray"}>0 &#8361;</P>
                                            :
                                            <P weight={"bold"} color={"var(--main-color)"}>{addCommas(data.total)} &#8361;</P>
                                        }
                                    </div>
                                </FlexChild>
                                <FlexChild width={"120px"} justifyContent={"center"} height={"120px"} >
                                    <VerticalFlex>
                                        <P weight={"bold"}>{t(`${status && status}`)}</P>
                                    </VerticalFlex>
                                </FlexChild>
                            </HorizontalFlex>
                        </div>
                    </FlexChild>

            }
        </div>

    );
}

export default OrderListRow;